import { render, staticRenderFns } from "./SensorAlarmColor.vue?vue&type=template&id=c3b5cc56"
import script from "./SensorAlarmColor.vue?vue&type=script&lang=js"
export * from "./SensorAlarmColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports